import FileThumbnail from 'components/elements/files/file-thumbnail'
import { TicketFile } from 'lib/api/ticket-files/ticket-files'
interface FilesListProps {
  files: TicketFile[]
}

export const FilesList = ({ files = [] }: FilesListProps) => {
  return (
    <div className="tw-flex tw-flex-wrap tw-gap-4 tw-py-4">
      {files.map((file) => (
        <FileThumbnail size="lg" key={`${file.id}-${file.createdAt}`} file={file} />
      ))}
    </div>
  )
}
